import React from 'react'
import { useForm } from 'react-hook-form'
import { TIME_SLOTS, TIME_ZONES } from '@/utilities'
import { ThreatProfileFormContent } from './ThreatProfileFormContent'
import { ModalFooter, Button, Loading } from '@maui/elements'
import { useThreatProfilesNotifications } from './useThreatProfilesNotifications'

// The original threat profile form
export const LegacyThreatProfileForm = ({
  user,
  threatProfiles,
  onClose,
  editData: data,
}) => {
  const { onSubmit, isSubmitting, error } = useThreatProfilesNotifications({ onClose, editData: data })

  const deliveryFreq = !data || data?.schedule?.days.length > 1 ? 'DAILY' : 'WEEKLY'

  const { handleSubmit, control, register, setError, clearErrors, setValue, formState: { errors, dirtyFields, isValid, isDirty } } = useForm({
    defaultValues: {
      name: data?.displayName || '',
      emailAddress: user.email,
      tpName: data?.config.profile_id,
      deliveryFreq,
      deliveryDays: data?.schedule?.days.map(String) || ['0', '1', '2', '3', '4', '5', '6'], // the api returns an array of numbers, but the form needs an array of strings
      deliveryTime: data?.schedule?.day_schedule.hour?.toString() || TIME_SLOTS[8].value,
      enableDayLightSavings: [data?.schedule.day_schedule?.ignore_dst ? 'dst' : ''],
      timeZone: data?.schedule.day_schedule?.time_zone || TIME_ZONES[0].value,
    }
  })

  React.useEffect(() => {
    if (error) {
      setError('root.serverError', {
        type: 'manual',
        message: error?.data?.detail || error.message
      })
    }
  }, [error, setError])

  return (
    <form onSubmit={handleSubmit(onSubmit(dirtyFields))}>
      <ThreatProfileFormContent
        control={control}
        register={register}
        threatProfiles={threatProfiles}
        deliveryFreq={deliveryFreq}
        errors={errors}
        clearErrors={clearErrors}
        setValue={setValue}
      />
      <ModalFooter mt="spaceGapXxLarge" gap="spaceGapMedium">
      { isSubmitting && <Loading /> }
        <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>Cancel</Button>
        <Button marginLeft="spaceGapXLarge" type="submit" disabled={isSubmitting || !isValid || !isDirty }>Save</Button>
      </ModalFooter>
    </form>
  )
}
